import clsx from 'clsx';
import { FC, HTMLAttributes, ReactNode } from 'react';
import styles from './ShowMoreButton.module.scss';

export interface IShowMoreButtonProps
  extends HTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  className?: string;
}

export const ShowMoreButton: FC<IShowMoreButtonProps> = (props) => {
  const { children, className, ...rest } = props;

  return (
    <button {...rest} className={clsx(styles.ShowMoreButton, className)}>
      {children}
    </button>
  );
};
